'use strict';
define([
    'angular',
    'modules/keywordlistmanager/wizard/wizard.controller'
], function (angular, KeywordListManagerWizardCtrl) {
    var app = angular.module('app.keywordlistmanager.wizard', []);
    app.controller('KeywordListManagerWizardCtrl', KeywordListManagerWizardCtrl);
    return app;
});
